export default "__VITE_PUBLIC_ASSET__beff75e3__"